import { useEffect, useState } from 'react';
import {
  DialogActions,
  DialogTitle,
  Divider,
  Button,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import makeStyles from '@material-ui/styles/makeStyles';
import { FormTextInput } from 'components';
import GridItem from 'components/Grid/GridItem';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedGridStyle';
import {
  grayColor,
  successColor,
  whiteColor,
} from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  ...buttonsStyle,
  ...extendedFormsStyle,
  root: {
    marginLeft: '5px',
    marginBottom: '10px',
    background: '#f3f3f3',
    padding: '10px 10px 5px',
    borderRadius: '10px',
  },
  dialog: {
    maxHeight: '700px',
  },
  divider: { marginBottom: '5px', marginTop: '15px' },
  dividerModal: {
    margin: '0 20px 15px',
  },
  button: {
    width: '100%',
  },
  accordionContent: {
    width: '100%',
  },
  buttonSave: {
    backgroundColor: successColor[0],
    color: whiteColor,
    padding: '5px 30px',
    '&:hover': {
      backgroundColor: successColor[2],
    },
  },
  clearButton: {
    backgroundColor: grayColor[0],
    color: whiteColor,
    padding: '5px 30px',
    '&:hover': {
      backgroundColor: grayColor[1],
    },
  },
});

const DietDetailsDietName = ({ dietInfo, handleSave, isOpen, setIsOpen }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [dietName, setDietName] = useState('');

  useEffect(() => {
    setDietName(dietInfo?.name || '-');
  }, [dietInfo]);

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <Dialog maxWidth="lg" fullWidth={true} open={isOpen} onClose={closeModal}>
      <DialogTitle>{t('ecommerceDiets.nameOfDiet')}</DialogTitle>
      <Divider className={classes.dividerModal} />
      <DialogContent className={classes.dialog}>
        <GridItem xs={6}>
          <FormTextInput
            label={t('ecommerceDiets.nameOfDiet')}
            name="name"
            value={dietName}
            inputSize={12}
            maxLength={64}
            handleChange={e => {
              setDietName(e.target.value);
            }}
          />
        </GridItem>
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button className={classes.clearButton} onClick={closeModal}>
          {t('common.cancel')}
        </Button>
        <Button
          disabled={!dietName}
          className={classes.buttonSave}
          onClick={() => {
            handleSave(dietName);
          }}
          color="success"
        >
          {t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DietDetailsDietName;
